var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"questionnaire-container"},[_c('div',{staticClass:"question-empty"},[_c('div',{staticClass:"question-bottom"},[_c('div',{ref:"lottieContainer",staticClass:"question-icon"}),_c('div',{staticClass:"question-title"},[_vm._v(" 根据您的身体状况 ")]),_c('div',{staticClass:"question-tip"},[_vm._v("正在为您构建专属的每日营养补充方案")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }